import { useMemo } from "react";

import { artworkUrl } from "@stonkland/protocol/art-urls";
import { productionTierLabel } from "@stonkland/protocol/production-art";

export function BrokerArtwork({ tokenId }: { tokenId: number }) {
  const tier = useMemo(() => productionTierLabel(tokenId), [tokenId]);
  return (
    <div className="pixel-broker">
      <img
        src={artworkUrl(tokenId)}
        alt={`Stonkland Broker artwork #${String(tokenId).padStart(4, "0")}: ${tier}`}
        width={1024}
        height={1024}
      />
    </div>
  );
}
